import * as THREE from 'three'
import React, { useRef } from 'react'
import { useAnimations, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
    nodes: {
        face: THREE.Mesh
    }
    materials: {
        ['Material.001']: THREE.MeshBasicMaterial
      }
}

type ActionName = 'Main'
type GLTFActions = Record<ActionName, THREE.AnimationAction>

const UserFace = function(props: JSX.IntrinsicElements['mesh'], ref: React.Ref<THREE.Mesh<THREE.BufferGeometry<THREE.NormalBufferAttributes>, THREE.Material | THREE.Material[]>> | undefined)  {
    const { nodes, materials, animations } = useGLTF('objects/face.gltf') as GLTFResult
    return (
        <group dispose={null}>
            <group name="Scene">
                <mesh
                    {...props}
                    ref={ref}
                    name="face"
                    geometry={nodes.face.geometry}
                    material={materials['Material.001']}
                    morphTargetDictionary={nodes.face.morphTargetDictionary}
                    morphTargetInfluences={nodes.face.morphTargetInfluences}
                    animations={animations}
                />
            </group>
        </group>
    )
}

export default React.forwardRef(UserFace)

useGLTF.preload('objects/face.gltf')